import { createAction } from '@reduxjs/toolkit';
import { SearchHubspotCompanyDTO } from '@reposit/api-client';
import {
  CreateOrganizationInvitePayload,
  CreateOrganizationPayload,
  SearchHubspotCompaniesPayload,
  UpdateOrganizationAddressPayload,
  UpdateOrganizationCommissionRulePayload,
  UpdateOrganizationHubspotIdPayload,
  UpdateOrganizationInventoryConfirmationDelayPayload,
  UpdateOrganizationNamePayload,
  UpdateOrganizationNotesPayload,
  UpdateOrganizationPolicyCoverCapPayload,
  UpdateOrganizationPricingRulePayload,
} from './organization.types';

export const FETCH_ORGANIZATION_BY_ID_STORE_KEY = 'ORGANIZATIONS/FETCH_ORGANIZATION_BY_ID_STORE_KEY';
export const FETCH_ORGANIZATION_BY_ID_API_REQUESTED = 'ORGANIZATIONS/FETCH_ORGANIZATION_BY_ID_API_REQUESTED';
export const FETCH_ORGANIZATION_BY_ID_API_SUCCESS = 'ORGANIZATIONS/FETCH_ORGANIZATION_BY_ID_API_SUCCESS';
export const FETCH_ORGANIZATION_BY_ID_API_FAILED = 'ORGANIZATIONS/FETCH_ORGANIZATION_BY_ID_API_FAILED';

export const CREATE_ORGANIZATION_STORE_KEY = 'ORGANIZATIONS/CREATE_ORGANIZATION';
export const CREATE_ORGANIZATION_API_REQUESTED = 'ORGANIZATIONS/CREATE_ORGANIZATION_API_REQUESTED';
export const CREATE_ORGANIZATION_API_SUCCESS = 'ORGANIZATIONS/CREATE_ORGANIZATION_API_SUCCESS';
export const CREATE_ORGANIZATION_API_FAILED = 'ORGANIZATIONS/CREATE_ORGANIZATION_API_FAILED';

export const CREATE_ORGANIZATION_INVITE_STORE_KEY = 'ORGANIZATIONS/CREATE_ORGANIZATION_INVITE';
export const CREATE_ORGANIZATION_INVITE_API_REQUESTED = 'ORGANIZATIONS/CREATE_ORGANIZATION_INVITE_API_REQUESTED';
export const CREATE_ORGANIZATION_INVITE_API_SUCCESS = 'ORGANIZATIONS/CREATE_ORGANIZATION_INVITE_API_SUCCESS';
export const CREATE_ORGANIZATION_INVITE_API_FAILED = 'ORGANIZATIONS/CREATE_ORGANIZATION_INVITE_API_FAILED';

export const UPDATE_ORG_NOTES_STORE_KEY = 'ORGANIZATIONS/UPDATE_NOTES';
export const UPDATE_ORG_ADDRESS_STORE_KEY = 'ORGANIZATIONS/UPDATE_ADDRESS';

export const UPDATE_ORGANIZATION_PRICING_RULE_STORE_KEY = 'ORGANIZATIONS/UPDATE_PRICING_RULE';
export const UPDATE_ORGANIZATION_PRICING_RULE_MODAL_STORE_KEY = 'ORGANIZATIONS/UPDATE_PRICING_RULE_MODAL';
export const UPDATE_ORGANIZATION_POLICY_COVER_CAP_STORE_KEY = 'ORGANIZATIONS/UPDATE_POLICY_COVER_CAP';
export const UPDATE_ORGANIZATION_POLICY_COVER_CAP_MODAL_STORE_KEY = 'ORGANIZATIONS/UPDATE_POLICY_COVER_CAP_MODAL';
export const UPDATE_ORGANIZATION_COMMISSION_RULE_STORE_KEY = 'ORGANIZATIONS/UPDATE_COMMISSION_RULE';
export const UPDATE_ORGANIZATION_COMMISSION_RULE_MODAL_STORE_KEY = 'ORGANIZATIONS/UPDATE_COMMISSION_RULE_MODAL';
export const UPDATE_ORGANIZATION_HUBSPOT_ID_STORE_KEY = 'ORGANIZATIONS/UPDATE_HUBSPOT_ID';
export const UPDATE_ORGANIZATION_HUBSPOT_ID_MODAL_STORE_KEY = 'ORGANIZATIONS/UPDATE_HUBSPOT_ID_MODAL';
export const UPDATE_ORGANIZATION_NAME_STORE_KEY = 'ORGANIZATIONS/UPDATE_NAME';
export const UPDATE_ORGANIZATION_NAME_MODAL_STORE_KEY = 'ORGANIZATIONS/UPDATE_NAME_MODAL';
export const UPDATE_ORGANIZATION_INVENTORY_CONFIRMATION_DELAY_STORE_KEY = 'ORGANIZATIONS/UPDATE_INVENTORY_CONFIRMATION_DELAY';
export const UPDATE_ORGANIZATION_INVENTORY_CONFIRMATION_DELAY_MODAL_STORE_KEY =
  'ORGANIZATIONS/UPDATE_INVENTORY_CONFIRMATION_DELAY_MODAL';
export const SEARCH_HUBSPOT_COMPANIES_STORE_KEY = 'ORGANIZATIONS/SEARCH_HUBSPOT_COMPANIES';

export const FETCH_ORGANIZATION_USERS_WITH_ROLES_STORE_KEY = 'ORGANIZATIONS/FETCH_ORGANIZATION_USERS_WITH_ROLES';
export const FETCH_ORGANIZATION_USERS_WITH_ROLES_API_REQUESTED =
  'ORGANIZATIONS/FETCH_ORGANIZATION_USERS_WITH_ROLES_API_REQUESTED';
export const FETCH_ORGANIZATION_USERS_WITH_ROLES_API_SUCCESS = 'ORGANIZATIONS/FETCH_ORGANIZATION_USERS_WITH_ROLES_API_SUCCESS';
export const FETCH_ORGANIZATION_USERS_WITH_ROLES_API_FAILED = 'ORGANIZATIONS/FETCH_ORGANIZATION_USERS_WITH_ROLES_API_FAILED';

// TODO change these to use Redux Toolkit

export function fetchOrganizationByIdRequested(organizationId: string) {
  return {
    type: FETCH_ORGANIZATION_BY_ID_API_REQUESTED,
    payload: {
      organizationId,
    },
  } as const;
}

export function fetchOrganizationByIdSuccess() {
  return {
    type: FETCH_ORGANIZATION_BY_ID_API_SUCCESS,
    payload: {},
  } as const;
}

export function fetchOrganizationByIdFailed(error: string) {
  return {
    type: FETCH_ORGANIZATION_BY_ID_API_FAILED,
    payload: error,
  } as const;
}

export function createOrganizationRequested(payload: CreateOrganizationPayload) {
  return {
    type: CREATE_ORGANIZATION_API_REQUESTED,
    payload,
  } as const;
}

export function createOrganizationSuccess() {
  return {
    type: CREATE_ORGANIZATION_API_SUCCESS,
    payload: {},
  } as const;
}

export function createOrganizationFailed(error: string) {
  return {
    type: CREATE_ORGANIZATION_API_FAILED,
    payload: error,
  } as const;
}

export function createOrganizationInviteRequested(payload: CreateOrganizationInvitePayload) {
  return {
    type: CREATE_ORGANIZATION_INVITE_API_REQUESTED,
    payload,
  } as const;
}

export function createOrganizationInviteSuccess() {
  return {
    type: CREATE_ORGANIZATION_INVITE_API_SUCCESS,
    payload: {},
  } as const;
}

export function createOrganizationInviteFailed(error: string) {
  return {
    type: CREATE_ORGANIZATION_INVITE_API_FAILED,
    payload: error,
  } as const;
}

export const updateOrganizationNotesRequested = createAction<UpdateOrganizationNotesPayload>(
  `${UPDATE_ORG_NOTES_STORE_KEY}_REQUESTED`,
);
export const updateOrganizationNotesSuccess = createAction(`${UPDATE_ORG_NOTES_STORE_KEY}_SUCCESS`);
export const updateOrganizationNotesFailed = createAction<string>(`${UPDATE_ORG_NOTES_STORE_KEY}_FAILED`);

export const updateOrganizationAddressRequested = createAction<UpdateOrganizationAddressPayload>(
  `${UPDATE_ORG_ADDRESS_STORE_KEY}_API_REQUESTED`,
);
export const updateOrganizationAddressSuccess = createAction(`${UPDATE_ORG_ADDRESS_STORE_KEY}_API_SUCCESS`);
export const updateOrganizationAddressFailed = createAction<string>(`${UPDATE_ORG_ADDRESS_STORE_KEY}_API_FAILED`);

export const updateOrganizationPricingRuleRequested = createAction<UpdateOrganizationPricingRulePayload>(
  `${UPDATE_ORGANIZATION_PRICING_RULE_STORE_KEY}_API_REQUESTED`,
);
export const updateOrganizationPricingRuleSuccess = createAction(`${UPDATE_ORGANIZATION_PRICING_RULE_STORE_KEY}_API_SUCCESS`);
export const updateOrganizationPricingRuleFailed = createAction<string>(
  `${UPDATE_ORGANIZATION_PRICING_RULE_STORE_KEY}_API_FAILED`,
);

export const updateOrganizationPolicyCoverCapRequested = createAction<UpdateOrganizationPolicyCoverCapPayload>(
  `${UPDATE_ORGANIZATION_POLICY_COVER_CAP_STORE_KEY}_API_REQUESTED`,
);
export const updateOrganizationPolicyCoverCapSuccess = createAction(
  `${UPDATE_ORGANIZATION_POLICY_COVER_CAP_STORE_KEY}_API_SUCCESS`,
);
export const updateOrganizationPolicyCoverCapFailed = createAction<string>(
  `${UPDATE_ORGANIZATION_POLICY_COVER_CAP_STORE_KEY}_API_FAILED`,
);

export const updateOrganizationCommissionRuleRequested = createAction<UpdateOrganizationCommissionRulePayload>(
  `${UPDATE_ORGANIZATION_COMMISSION_RULE_STORE_KEY}_API_REQUESTED`,
);
export const updateOrganizationCommissionRuleSuccess = createAction(
  `${UPDATE_ORGANIZATION_COMMISSION_RULE_STORE_KEY}_API_SUCCESS`,
);
export const updateOrganizationCommissionRuleFailed = createAction<string>(
  `${UPDATE_ORGANIZATION_COMMISSION_RULE_STORE_KEY}_API_FAILED`,
);

export const updateOrganizationHubspotIdRequested = createAction<UpdateOrganizationHubspotIdPayload>(
  `${UPDATE_ORGANIZATION_HUBSPOT_ID_STORE_KEY}_API_REQUESTED`,
);
export const updateOrganizationHubspotIdSuccess = createAction(`${UPDATE_ORGANIZATION_HUBSPOT_ID_STORE_KEY}_API_SUCCESS`);
export const updateOrganizationHubspotIdFailed = createAction<string>(`${UPDATE_ORGANIZATION_HUBSPOT_ID_STORE_KEY}_API_FAILED`);

export const updateOrganizationNameRequested = createAction<UpdateOrganizationNamePayload>(
  `${UPDATE_ORGANIZATION_NAME_STORE_KEY}_API_REQUESTED`,
);
export const updateOrganizationNameSuccess = createAction(`${UPDATE_ORGANIZATION_NAME_STORE_KEY}_API_SUCCESS`);
export const updateOrganizationNameFailed = createAction<string>(`${UPDATE_ORGANIZATION_NAME_STORE_KEY}_API_FAILED`);

export const updateOrganizationInventoryConfirmationDelayRequested =
  createAction<UpdateOrganizationInventoryConfirmationDelayPayload>(
    `${UPDATE_ORGANIZATION_INVENTORY_CONFIRMATION_DELAY_STORE_KEY}_API_REQUESTED`,
  );
export const updateOrganizationInventoryConfirmationDelaySuccess = createAction(
  `${UPDATE_ORGANIZATION_INVENTORY_CONFIRMATION_DELAY_STORE_KEY}_API_SUCCESS`,
);
export const updateOrganizationInventoryConfirmationDelayFailed = createAction<string>(
  `${UPDATE_ORGANIZATION_INVENTORY_CONFIRMATION_DELAY_STORE_KEY}_API_FAILED`,
);

export const searchHubspotCompaniesRequested = createAction<SearchHubspotCompaniesPayload>(
  `${SEARCH_HUBSPOT_COMPANIES_STORE_KEY}_API_REQUESTED`,
);
export const searchHubspotCompaniesSuccess = createAction<SearchHubspotCompanyDTO[]>(
  `${SEARCH_HUBSPOT_COMPANIES_STORE_KEY}_API_SUCCESS`,
);
export const searchHubspotCompaniesFailed = createAction<string>(`${SEARCH_HUBSPOT_COMPANIES_STORE_KEY}_API_FAILED`);

export function fetchOrganizationUsersWithRolesRequested(organizationId: string) {
  return {
    type: FETCH_ORGANIZATION_USERS_WITH_ROLES_API_REQUESTED,
    payload: organizationId,
  } as const;
}

export function fetchOrganizationUsersWithRolesSuccess(payload: string[]) {
  return {
    type: FETCH_ORGANIZATION_USERS_WITH_ROLES_API_SUCCESS,
    payload,
  } as const;
}

export function fetchOrganizationUsersWithRolesFailed(error: string) {
  return {
    type: FETCH_ORGANIZATION_USERS_WITH_ROLES_API_FAILED,
    payload: error,
  } as const;
}

export type OrganizationActionTypes = ReturnType<
  | typeof fetchOrganizationByIdRequested
  | typeof fetchOrganizationByIdSuccess
  | typeof fetchOrganizationByIdFailed
  | typeof createOrganizationRequested
  | typeof createOrganizationSuccess
  | typeof createOrganizationFailed
  | typeof createOrganizationInviteRequested
  | typeof createOrganizationInviteSuccess
  | typeof createOrganizationInviteFailed
  | typeof updateOrganizationNotesRequested
  | typeof updateOrganizationNotesSuccess
  | typeof updateOrganizationNotesFailed
  | typeof updateOrganizationAddressRequested
  | typeof updateOrganizationAddressSuccess
  | typeof updateOrganizationAddressFailed
  | typeof updateOrganizationPricingRuleRequested
  | typeof updateOrganizationPricingRuleSuccess
  | typeof updateOrganizationPricingRuleFailed
  | typeof updateOrganizationPolicyCoverCapRequested
  | typeof updateOrganizationPolicyCoverCapSuccess
  | typeof updateOrganizationPolicyCoverCapFailed
  | typeof updateOrganizationCommissionRuleRequested
  | typeof updateOrganizationCommissionRuleSuccess
  | typeof updateOrganizationCommissionRuleFailed
  | typeof updateOrganizationHubspotIdRequested
  | typeof updateOrganizationHubspotIdSuccess
  | typeof updateOrganizationHubspotIdFailed
  | typeof updateOrganizationNameRequested
  | typeof updateOrganizationNameSuccess
  | typeof updateOrganizationNameFailed
  | typeof updateOrganizationInventoryConfirmationDelayRequested
  | typeof updateOrganizationInventoryConfirmationDelaySuccess
  | typeof updateOrganizationInventoryConfirmationDelayFailed
  | typeof searchHubspotCompaniesRequested
  | typeof searchHubspotCompaniesSuccess
  | typeof searchHubspotCompaniesFailed
  | typeof fetchOrganizationUsersWithRolesRequested
  | typeof fetchOrganizationUsersWithRolesSuccess
  | typeof fetchOrganizationUsersWithRolesFailed
>;
